import { comicCategories } from "@/mocks/comics";

interface CategoriesProps {
  active: string;
  onSelect: (key: string) => void;
}

export default function Categories({ active, onSelect }: CategoriesProps) {
  const handleSelect = (key: string) => {
    onSelect(key);
    document.getElementById("updates")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="categories" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-9 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-bold tracking-wide text-primary-600">MANGA CATEGORIES</span>
            <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">选择你的快乐入口</h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              按恶搞反转、神展开、脑洞大开、魔性沙雕与爆笑日常分门别类，一眼找到你最想追的那一部。
            </p>
          </div>
          <a
            href="#updates"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {comicCategories.map((c) => {
            const selected = active === c.key;
            return (
              <button
                key={c.key}
                onClick={() => handleSelect(c.key)}
                className={`group flex flex-col items-center justify-center gap-3 rounded-2xl border px-4 py-6 text-center transition-all ${
                  selected
                    ? "border-primary-300 bg-primary-50"
                    : "border-background-200 bg-background-100 hover:border-primary-200 hover:bg-background-50"
                }`}
              >
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-full text-xl transition-transform group-hover:scale-110 ${c.color}`}
                >
                  <i className={c.icon}></i>
                </span>
                <span
                  className={`text-sm font-bold ${
                    selected ? "text-primary-700" : "text-foreground-800"
                  }`}
                >
                  {c.key}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}